var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZap = function SvgZap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.398 1.083a1 1 0 0 1 .594 1.041L13.132 9h6.196c.24 0 .485 0 .684.018.189.017.55.062.863.315a1.5 1.5 0 0 1 .557 1.19c-.006.402-.202.709-.31.864-.114.165-.27.353-.424.538l-8.93 10.715a1 1 0 0 1-1.76-.764l.86-6.876H4.671c-.24 0-.485 0-.684-.018-.189-.017-.55-.062-.863-.315a1.5 1.5 0 0 1-.557-1.19c.006-.402.202-.709.31-.864.114-.165.27-.353.424-.538l.023-.027L12.232 1.36a1 1 0 0 1 1.166-.277M5.135 13H12a1 1 0 0 1 .992 1.124l-.577 4.616 6.45-7.74H12a1 1 0 0 1-.992-1.124l.577-4.615z",
    clipRule: "evenodd"
  })));
};
export default SvgZap;